import React from 'react';
import { useApi, fmtKST } from '../hooks/useApi';
import BotAvatar from './BotAvatar';

export default function PersonaComments({ limit = 20 }) {
  const { data, loading } = useApi(`/api/persona/comments?limit=${limit}`);
  const { data: status } = useApi('/api/persona/comments/status');

  if (loading) return <div className="animate-pulse h-32 bg-gray-800 rounded-lg" />;

  return (
    <div className="bg-gray-800 rounded-lg border border-gray-700">
      <div className="p-3 border-b border-gray-700">
        <h3 className="text-sm font-semibold text-gray-400">봇 코멘트</h3>
      </div>
      {status?.stale && (
        <div className="px-3 py-2 text-xs text-yellow-300 bg-yellow-900/20 border-b border-yellow-700/40">
          ⚠️ {status.collection_message} (최근: {status.latest_comment_at || '없음'})
        </div>
      )}
      {!data || data.length === 0 ? (
        <div className="p-4 text-sm text-gray-500">봇 코멘트 없음</div>
      ) : (
        <div className="divide-y divide-gray-700/50 max-h-96 overflow-y-auto">
          {data.map((c, i) => {
            const decisionColor = c.decision === 'BUY' ? 'text-green-400' :
                                  c.decision === 'SELL' ? 'text-red-400' : 'text-gray-400';
            return (
              <div key={i} className="p-3 flex gap-3">
                <BotAvatar botName={c.bot_name} size="sm" />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 text-xs mb-1">
                    <span className="font-semibold">{c.bot_name}</span>
                    {c.ticker && <span className="text-blue-400">{c.ticker}</span>}
                    {c.decision && <span className={decisionColor}>{c.decision}</span>}
                    {c.confidence != null && (
                      <span className="text-gray-500">{Number(c.confidence).toFixed(0)}%</span>
                    )}
                    <span className="text-gray-600 ml-auto">{fmtKST(c.created_at)}</span>
                  </div>
                  <div className="text-xs text-gray-300 whitespace-pre-wrap">{c.comment}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
